import {user} from '../router/user';

const rootPath = user.path;
const menus = [];

user.children.forEach(menu => {
  const { path, name } = menu;
  const { icon, isParent } = menu.meta || {};
  if (isParent) {
    menus.push({
      path: rootPath + '/' + path,
      name,
      icon,
    });
  }
});

export default menus;
